import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: {
      title: 'FicPod - Discover Self-Published Fiction'
    }
  },
  {
    path: '/works',
    name: 'works',
    component: () => import('../views/WorksView.vue'),
    meta: {
      title: 'Browse Works - FicPod'
    }
  },
  {
    path: '/works/:id',
    name: 'work-detail',
    component: () => import('../views/WorkDetailView.vue'),
    meta: {
      title: 'Work - FicPod'
    }
  },
  {
    path: '/works/:id/chapters/:chapter',
    name: 'chapter',
    component: () => import('../views/ChapterView.vue'),
    meta: {
      title: 'Chapter - FicPod'
    }
  },
  {
    path: '/my-works',
    name: 'my-works',
    component: () => import('../views/MyWorksView.vue'),
    meta: {
      title: 'My Works - FicPod'
    }
  },
  {
    path: '/works/new',
    name: 'create-work',
    component: () => import('../views/CreateWorkView.vue'),
    meta: {
      title: 'Create Work - FicPod'
    }
  },
  {
    path: '/works/:id/edit',
    name: 'edit-work',
    component: () => import('../views/EditWorkView.vue'),
    meta: {
      title: 'Edit Work - FicPod'
    }
  },
  {
    path: '/works/:id/chapters',
    name: 'work-chapters',
    component: () => import('../views/WorkChaptersView.vue'),
    meta: {
      title: 'Manage Chapters - FicPod'
    }
  },
  {
    path: '/works/:id/chapters/:chapterId/edit',
    name: 'edit-chapter',
    component: () => import('../views/EditChapterView.vue'),
    meta: {
      title: 'Edit Chapter - FicPod'
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminView.vue'),
    meta: {
      title: 'Admin Console - FicPod'
    }
  },
  {
    path: '/gather',
    name: 'gather-home',
    component: () => import('../views/gather/HomeView.vue'),
    meta: {
      title: 'Gather - FicPod Community'
    }
  },
  {
    path: '/gather/boards/:id',
    name: 'board',
    component: () => import('../views/gather/BoardView.vue'),
    meta: {
      title: 'Board - Gather'
    }
  },
  {
    path: '/gather/posts/:id',
    name: 'post',
    component: () => import('../views/gather/PostView.vue'),
    meta: {
      title: 'Post - Gather'
    }
  },
  {
    path: '/gather/create',
    name: 'create-post',
    component: () => import('../views/gather/CreatePostView.vue'),
    meta: {
      title: 'Create Post - Gather'
    }
  },
  {
    path: '/gather/boards/:boardId/posts/:postId/edit',
    name: 'edit-post',
    component: () => import('../views/gather/EditPostView.vue'),
    meta: {
      title: 'Edit Post - Gather'
    }
  },
  {
    path: '/gather/popular',
    name: 'popular',
    component: () => import('../views/gather/PopularView.vue'),
    meta: {
      title: 'Popular - Gather'
    }
  },
  {
    path: '/gather/recent',
    name: 'recent',
    component: () => import('../views/gather/RecentView.vue'),
    meta: {
      title: 'Recent - Gather'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: {
      title: 'Sign In - FicPod'
    }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('../views/SignupView.vue'),
    meta: {
      title: 'Sign Up - FicPod'
    }
  },
  {
    path: '/auth/callback',
    name: 'auth-callback',
    component: () => import('../views/AuthCallbackView.vue'),
    meta: {
      title: 'Authenticating... - FicPod'
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue'),
    meta: {
      title: 'Profile - FicPod'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/HomeView.vue'),
    meta: {
      title: 'Page Not Found - FicPod'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.beforeEach((to, _from, next) => {
  document.title = (to.meta.title as string) || 'FicPod'
  next()
})

router.onError((error) => {
  console.error('Router error:', error)
})

export default router
